import { render, staticRenderFns } from "./Shadows.vue?vue&type=template&id=2f6fea48&scoped=true&"
import script from "./Shadows.vue?vue&type=script&lang=js&"
export * from "./Shadows.vue?vue&type=script&lang=js&"
import style0 from "./Shadows.vue?vue&type=style&index=0&id=2f6fea48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6fea48",
  null
  
)

export default component.exports